import { afterRenderEffect, Component, ElementRef, ViewChild, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { ChatWidgetService } from '../../core/services/chat-widget.service';
import { parseMessageLines } from '../../core/services/chat-message-lines';

/** Full-screen sibling of the floating case assistant — same conversation, more room to read. */
@Component({
  selector: 'app-assistant',
  standalone: true,
  imports: [FormsModule, RouterLink],
  templateUrl: './assistant.component.html',
  styleUrl: './assistant.component.scss',
})
export class AssistantComponent {
  readonly widget = inject(ChatWidgetService);
  readonly parseMessageLines = parseMessageLines;

  @ViewChild('composerInput') private composerInput?: ElementRef<HTMLInputElement>;
  @ViewChild('scrollBody') private scrollBody?: ElementRef<HTMLElement>;

  constructor() {
    // Runs after the DOM reflects the latest messages / typing indicator.
    afterRenderEffect(() => {
      this.widget.messages().length;
      this.widget.asking();
      const el = this.scrollBody?.nativeElement;
      if (el) el.scrollTop = el.scrollHeight;
    });
  }

  focusComposer(): void {
    this.composerInput?.nativeElement.focus();
  }
}
